import React, {Component} from 'react';
import {TabContent, TabPane, Nav, NavItem, NavLink, Progress, Label, Input} from 'reactstrap';
import classnames from 'classnames';

import AuthStore from '../../stores/AuthStore';
//Twilio
import $ from 'jquery';
import TwilioSDK from '../../components/twilio';
import twilioInstance from "../../twilioInstance.js";
import twilioChatClient from "../../twilioChatClient.js";
import TwilioChat from 'twilio-chat';

class AsideTwillio extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.openChat = this.openChat.bind(this);
    //this.getUnreadedMessagesCount = this.getUnreadedMessagesCount.bind(this);

    this.state = {
      activeTab: '1'
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

 openChat(channel){
   twilioChatClient.getOrCreateChannel(channel.uniqueName, channel.friendlyName);
   document.body.classList.toggle('aside-menu-hidden');
 }

 componentWillReceiveProps(newProps){
   newProps.channelsList.map((channel) =>{
     channel.getUnconsumedMessagesCount().then( count => {
       channel.unreadedMessagesCount = count;

       this.setState({"channelsList": newProps.channelsList});
     });
   });

 }

  render() {
    if(this.props.channelsList == null) return ("");

    let channelsList = this.props.channelsList.map((channel) =>
        <div className="message" key={channel.uniqueName} onClick={function(){this.openChat(channel)}.bind(this)}>
          <div>
            <small className="text-muted"><b className={(channel.unreadedMessagesCount > 0 ? "text-danger" : "")}>{channel.friendlyName + "("+channel.unreadedMessagesCount+")"}</b></small>
            <small className="text-muted float-right mt-1">{
              new Date(channel.dateUpdated).getDay() + "/" +
              (new Date(channel.dateUpdated).getMonth()+1) + "/" +
              new Date(channel.dateUpdated).getFullYear()
            }</small>
          </div>

          <small className="text-muted">
            {channel.lastMessage == undefined ? 'Nenhuma mensagem para exibir.' : channel.lastMessage.body }
          </small>
        <hr/>
      </div>
    );

    return (
      <aside className="aside-menu">
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                     onClick={() => { this.toggle('1'); }}>
              <i className="icon-speech"></i>
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>

          <TabPane tabId="1" className="p-3">
            {channelsList}
          </TabPane>
        </TabContent>
      </aside>
    )
  }
}

export default AsideTwillio;



// WEBPACK FOOTER //
// ./src/components/AsideTwillio/AsideTwillio.js